import type { AdType } from '../../../configs';
import { adTypes } from '../../../configs';
import {
  AdSelectorSlateCreativeBuilder,
  AdSelectorVideoCreativeBuilder,
  BrightlineCreativeBuilder,
  DxcCreativeBuilder,
  GatewayGoCreativeBuilder,
  InnovidCreativeBuilder,
  PauseCreativeBuilder,
  SlateCreativeBuilder,
  VideoCreativeBuilder,
} from '../CreativeBuilders';
import type { CreativeBuilderProps } from '../CreativeBuilders/CreativeBuilder/CreativeBuilder';
import { wrapWithDraxMagniteCreativeBuilder } from '../CreativeBuilders/utils/wrapWithDraxMagniteCreativeBuilder';
import { wrapWithDxcCreativeBuilder } from '../CreativeBuilders/utils/wrapWithDxcCreativeBuilder';

export const creativeBuilderByAdType: Record<AdType, (props: CreativeBuilderProps) => React.JSX.Element> = {
  UNKNOWN: VideoCreativeBuilder,
  AD_SELECTOR_SLATE: AdSelectorSlateCreativeBuilder,
  AD_SELECTOR_VIDEO: AdSelectorVideoCreativeBuilder,
  AD_SELECTOR: BrightlineCreativeBuilder,
  BRIGHTLINE: wrapWithDraxMagniteCreativeBuilder(BrightlineCreativeBuilder),
  COLLECTION_LOGO: BrightlineCreativeBuilder,
  COVER_STORY_LOGO: BrightlineCreativeBuilder,
  GATEWAY_GO: wrapWithDxcCreativeBuilder(GatewayGoCreativeBuilder),
  GATEWAY_SHOP: wrapWithDraxMagniteCreativeBuilder(BrightlineCreativeBuilder),
  HUB_LOGO: BrightlineCreativeBuilder,
  INNOVID: InnovidCreativeBuilder,
  MARQUEE_PROMOTED_CONTENT: BrightlineCreativeBuilder,
  MAX_SELECTOR: wrapWithDraxMagniteCreativeBuilder(BrightlineCreativeBuilder),
  PAUSE: PauseCreativeBuilder,
  PAUSE_QR: PauseCreativeBuilder,
  SLATE: SlateCreativeBuilder,
  VIDEO: VideoCreativeBuilder,
  BE_SELECTOR_SLATE: SlateCreativeBuilder,
  BE_SELECTOR_VIDEO: VideoCreativeBuilder,
  OUTSTREAM_DXC: wrapWithDxcCreativeBuilder(DxcCreativeBuilder),
  INSTREAM_DXC: DxcCreativeBuilder,
};

export const HIDE_BUILD_NEW_CREATIVE_BLOCK_AD_TYPES: AdType[] = [adTypes.INSTREAM_DXC.key, adTypes.OUTSTREAM_DXC.key];
